module.exports = __webpack_public_path__ + "img/xuebitu.3744e150.jpg";